import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { getResponsiveHeight, getResponsiveSize } from "../../utils/responsive";
import globalStyles from "../../global";
import { useTranslation } from "react-i18next";

const OurMission = ({
  country = "Nepal",
  containerWidth = {
    mobile: "90%",
    tablet: "80%",
    desktop: "100%", // Changed to 100% for full width
  },
  fontSizes = {
    heading: 45,
    paragraph: 18,
  },
  colors = {
    heading: globalStyles.colors.army_green,
    text: globalStyles.colors.uclean_medium_gray,
  },
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const { t } = useTranslation();

  const getResponsiveFontSizes = (baseFontSize) => ({
    xs: baseFontSize * 0.7,
    sm: baseFontSize * 0.8,
    md: baseFontSize,
  });

  const fontSizeSettings = {
    heading: getResponsiveFontSizes(fontSizes.heading),
    paragraph: getResponsiveFontSizes(fontSizes.paragraph),
  };

  return (
    <Box
      sx={{
        width: {
          xs: "100%",
          sm: "80%",
          md: "62%",
        },
        margin: "auto",
        px: {
          xs: getResponsiveSize(0),
          sm: getResponsiveSize(0),
          md: getResponsiveSize(0),
        },
      }}
    >
      <Box
        sx={{
          width: isMobile
            ? containerWidth.mobile
            : isTablet
            ? containerWidth.tablet
            : containerWidth.desktop,
          margin: "0 auto",
          paddingBottom: getResponsiveSize(5),
        }}
      >
        <Typography
          sx={{
            ...styles.typography,
            fontSize: isMobile
              ? getResponsiveSize(fontSizeSettings.heading.sm)
              : getResponsiveSize(fontSizeSettings.heading.md),
            color: colors.heading,
            textAlign: "left", // Always left aligned
            marginLeft: 0, // Explicitly remove left margin
          }}
        >
          {t("ourMission.title", { country })}
        </Typography>

        <Typography
          sx={{
            ...styles.text1,
            fontSize: isMobile
              ? fontSizeSettings.paragraph.xs
              : fontSizeSettings.paragraph.sm,
            color: colors.text,
            textAlign: "left", // Always left aligned
            margin: 0, // Remove margins
            marginTop: getResponsiveSize(2), // Add only top margin
            maxWidth: "100%", // Allow full width
          }}
        >
          {t("ourMission.description", { country })}
        </Typography>
      </Box>
    </Box>
  );
};

const styles = {
  typography: {
    fontFamily: ' "Poppins", serif ',
    fontWeight: 700,
    lineHeight: 1.2,
    mt: getResponsiveHeight(5),
  },
  text1: {
    fontFamily: ' "Poppins", serif ',
    fontWeight: 400,
    padding: 0, // Removed padding
    lineHeight: 1.6,
    mb: getResponsiveHeight(4),
  },
};

export default OurMission;